import PlanesContainer from './containers/PlanesContainer';

export default PlanesContainer;